import {useAi as _useAiChat} from '@/biz/ai/chat'
import {useAi as _useAiWorkflow} from '@/biz/ai/workflow'

export const useAiChat = ({title, ...options}) => {
    return {
        ..._useAiChat(options),

        getTitle() {
            return title
        }
    }
}

export const useAiWorkflow = ({title, ...options}) => {
    return {
        ..._useAiWorkflow(options),

        getTitle() {
            return title
        }
    }
}
